/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Open_ButtonInputs */



/**
* | output |
* | --- |
* | "Send feedback" |
*
* @param {Feedback_Open_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_open_button = /** @type {((inputs?: Feedback_Open_ButtonInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Open_ButtonInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Envoyer un commentaire")
	if (locale === "es") return /** @type {LocalizedString} */ ("Enviar comentario")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Enviar feedback")
	if (locale === "it") return /** @type {LocalizedString} */ ("Invia feedback")
	return /** @type {LocalizedString} */ ("Send feedback")
});